export default "__VITE_ASSET__e7ee2389__"